import React from 'react'
import { Button, ConfigProvider, Flex, Form } from 'antd'
import { FormattedMessage } from 'react-intl'

import NewPasswordFields from './NewPasswordFields'
import { FORM_THEME } from './theme'

/**
 * Answers Cognito's NEW_PASSWORD_REQUIRED challenge, which a user created by an
 * administrator meets on their first sign-in with the temporary password.
 */
export default function NewPasswordForm({ onSubmit, onBack, busy }) {
  return (
    <ConfigProvider theme={FORM_THEME}>
      <Form
        layout="vertical"
        requiredMark={false}
        disabled={busy}
        onFinish={({ new_password }) => onSubmit({ new_password })}
        data-testid="login-new-password-form"
      >
        <NewPasswordFields autoFocus={true} />

        <Flex vertical={true} gap="small">
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            data-testid="login-submit"
            loading={busy}
          >
            <FormattedMessage id="auth.setPassword" />
          </Button>

          <Flex justify="center">
            <Button type="link" onClick={onBack}>
              <FormattedMessage id="auth.backToSignIn" />
            </Button>
          </Flex>
        </Flex>
      </Form>
    </ConfigProvider>
  )
}
